<template>
  <div>
    <div class="content">
      <span ref="headerDrawer" id="headerDrawer"></span>
      <div class="gift-ready-label">
        Escolha uma ou mais listas que mais combina com o seu evento.
      </div>

      <div class="gift-category-search">
        <b-sidebar
          class="filter-sidebar big-modal"
          fullheight="fullheight"
          :fullwidth="fullwidth"
          :overlay="overlay"
          :right="right"
          v-model="open"
        >
          <div class="filter-gifts-sidebar">
            <div class="filter-header">
              <img
                @click="closeFilters"
                class="filter-header-back"
                :src="arrowBack"
              />
              Filtrar
              <span v-if="!!categoriesSelected.length" class="counter">
                {{ categoriesSelected.length }}
              </span>
            </div>
            <div class="filter-content">
              <div class="filter-content-category-title">Categoria</div>

              <div v-for="(item, index) in giftsAutomaticList" :key="index">
                <div class="gift-filters-section">{{ item.name }}</div>
                <div
                  v-for="(list, index) in item.gifts_lists"
                  :key="index"
                  class="gift-filters-item"
                >
                  <b-field>
                    <b-checkbox
                      v-model="categoriesSelected"
                      :native-value="list.name"
                    >
                      {{ list.name }}
                    </b-checkbox>
                  </b-field>
                </div>
                <div class="gift-filter-divider"></div>
              </div>
            </div>
          </div>
          <div class="filter-gifts-sidebar-footer">
            <div class="wrapper-buttons">
              <button
                :disabled="!categoriesSelected.length"
                class="button is-outlined btn-clean"
                @click="cleanFilters"
              >
                Limpar filtros
              </button>
              <button
                :disabled="!categoriesSelected.length"
                class="button is-primary"
                @click="closeFilters"
              >
                Aplicar filtros
              </button>
            </div>
          </div>
        </b-sidebar>

        <b-sidebar
          class="filter-sidebar big-modal"
          fullheight="fullheight"
          :fullwidth="fullwidth"
          :overlay="overlay"
          :right="right"
          v-model="selectedList"
        >
          <div class="filter-gifts-sidebar">
            <div class="filter-header">
              <img
                @click="closeSelectList"
                class="filter-header-back"
                :src="arrowBack"
              />
              Utilizar uma lista pronta
            </div>
            <div class="filter-content ready-list">
              <div class="ready-list-title">{{ listSelected.name }}</div>
              <div class="ready-list-subtitle">
                <span class="ready-list-subtitle-bold"
                  >{{ listSelected.count }} itens |</span
                >
                Total da lista: {{ getGiftValue(listSelected.total_amount) }}
              </div>
              <div class="ready-list-text">
                Os valores dos presentes são apenas sugestivos, você poderá
                editá-los após adicionar esta lista de presentes.
              </div>
              <div class="gift-category">
                <div
                  v-for="gift in giftsFiltered"
                  :key="gift.id"
                  class="gift-items-card without-border"
                >
                  <div class="gift-items-card-content">
                    <img
                      class="gift-items-card-image"
                      :src="getGiftUrlImage(gift.img)"
                    />
                    <div class="gift-items-card-title">{{ gift.name }}</div>
                    <div class="gift-items-card-value">
                      {{ getGiftValue(gift.value) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filter-gifts-sidebar-footer">
            <div class="wrapper-buttons">
              <button class="button is-primary" @click="openConfirmation">
                Escolher essa lista
              </button>
            </div>
          </div>
        </b-sidebar>

        <b-sidebar
          class="filter-sidebar"
          fullheight="fullheight"
          :fullwidth="fullwidth"
          :overlay="overlay"
          :right="right"
          v-model="confirmation"
        >
          <div class="filter-gifts-sidebar">
            <div class="filter-header">
              <img
                @click="() => (confirmation = false)"
                class="filter-header-back"
                :src="arrowBack"
              />
              Confirmação
            </div>
            <div class="filter-content">
              <div class="filter-content-confirmation-title">
                Você já possui uma lista de presentes. O que deseja fazer com a
                sua lista atual?
              </div>
              <div
                class="filter-content-confirmation-option"
                @click="addGiftsAutomaticList(listSelected.id, 'add')"
              >
                <div class="filter-content-confirmation-option-image">
                  <img :src="plusAdd" />
                </div>
                <div class="filter-content-confirmation-text">
                  <div class="confirmation-title">
                    Adicionar presentes à lista atual
                  </div>
                  <div class="confirmation-subtitle">
                    A lista selecionada será adicionada à lista existente. Os
                    presentes atuais da sua lista não serão apagados.
                  </div>
                </div>
                <div class="filter-content-confirmation-arrow">
                  <img :src="arrowRight" />
                </div>
              </div>

              <div
                class="filter-content-confirmation-option"
                @click="addGiftsAutomaticList(listSelected.id, 'replace')"
              >
                <div class="filter-content-confirmation-option-image">
                  <img :src="publishedIcon" />
                </div>
                <div class="filter-content-confirmation-text">
                  <div class="confirmation-title">
                    Substituir lista de presentes atual
                  </div>
                  <div class="confirmation-subtitle">
                    Sua lista atual será removida (inclusive presentes
                    customizados).
                  </div>
                </div>
                <div class="filter-content-confirmation-arrow">
                  <img :src="arrowRight" />
                </div>
              </div>
            </div>
          </div>
        </b-sidebar>
        <div class="filter-button-wrapper">
          <button
            class="filter-button"
            :class="{
              'filter-button-active': !!categoriesSelected.length,
            }"
            @click="openFilters"
          >
            <img :src="filterImg" /> Filtrar
            <span v-if="categoriesSelected.length" class="filter-count">{{
              categoriesSelected.length
            }}</span>
          </button>
        </div>
        <div
          class="filter-element filter-mobile"
          v-if="categoriesSelected.length"
        >
          <span v-for="(category, index) in categoriesSelected" :key="index">
            <div class="filter-element-item">
              <div class="filter-text">{{ category }}</div>
              <img
                :src="closeImg"
                @click="removeFromSearch(category)"
                class="close-search"
              />
            </div>
          </span>
        </div>
        <div class="gift-edit-search">
          <div class="gift-list-search-wrapper">
            <img :src="searchIcon" class="icon-search" />
            <input
              v-on:keyup="queringPag"
              type="text"
              v-model="query"
              class="gift-list-search"
              placeholder="buscar listas automáticas"
            />
          </div>
        </div>
      </div>
      <div
        class="filter-element filter-desktop"
        v-if="categoriesSelected.length"
      >
        <span v-for="(category, index) in categoriesSelected" :key="index">
          <div class="filter-element-item">
            <div class="filter-text">{{ category }}</div>
            <img
              :src="closeImg"
              @click="removeFromSearch(category)"
              class="close-search"
            />
          </div>
        </span>
      </div>
      <div class="gift-category">
        <div
          v-for="(item, index) in giftsAutomaticListFilteredWithPaginate"
          :key="index"
        >
          <div class="gift-category-section" v-if="item.gifts_lists.length">
            {{ item.name }}
          </div>
          <div class="gift-items-card-row">
            <div
              v-for="(list, index) in item.gifts_lists"
              :key="index"
              class="gift-items-card"
              @click="openSelectedList(list)"
            >
              <div
                v-if="item.gifts_lists.length"
                class="gift-items-card-content"
              >
                <img
                  class="gift-items-card-image"
                  :src="getListUrlImage(list.img)"
                />
                <div class="gift-items-card-title">{{ list.name }}</div>
                <div class="gift-items-card-value">
                  {{ list.count }} itens
                  <br />
                  Total da lista: {{ getGiftValue(list.total_amount) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gift-category-footer">
        <button
          class="button is-primary"
          @click="loadMoreGifts"
          v-if="seeMoreVisibility"
        >
          <img :src="plusAddCircle" /> Ver mais listas
        </button>
        <div class="btn-back-initial">
          <a @click="goTop()"><img :src="arrowUp" />voltar ao início</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GiftsApi from '@/lib/api/Gifts'
import isMobileBrowser from '@/plugins/detect-mobile-browser'

import uploadImage from '@/assets/img/readylist.png'
import plusAdd from '@/assets/img/plus-add-pink.svg'
import plusAddCircle from '@/assets/img/plus-add-circle.svg'
import arrowUp from '@/assets/img/arrow-up.svg'
import searchIcon from '@/assets/img/search-icon.svg'
import filterImg from '@/assets/img/filter.svg'
import arrowBack from '@/assets/img/arrow-back.svg'
import closeImg from '@/assets/img/close-white.svg'
import arrowRight from '@/assets/img/chevron-right-grey.svg'
import publishedIcon from '@/assets/img/published-icon.svg'
import { sortGifts } from './GiftListUtils'

const INITIAL_COUNT = 2
const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  data() {
    return {
      open: false,
      overlay: false,
      fullheight: true,
      fullwidth: false,
      right: true,

      confirmation: false,
      selectedList: false,

      uploadImage,
      plusAdd,
      plusAddCircle,
      arrowUp,
      searchIcon,
      filterImg,
      arrowBack,
      closeImg,
      arrowRight,
      publishedIcon,

      giftsAutomaticListSaved: [],
      giftsAutomaticList: [],
      categoriesSelected: [],
      gifts: [],
      listSelected: {},
      giftCount: INITIAL_COUNT,
      query: null,
    }
  },

  mounted() {
    this.getGiftsAutomaticListsInfo()
  },

  computed: {
    ...mapGetters({
      wedId: 'app/getWedId',
      logonToken: 'app/logonToken',
      giftsListSaved: 'gifts/getGiftsList',
    }),

    giftsFiltered() {
      if (!this.gifts.length) return []

      return sortGifts(this.gifts, 'small')
    },

    giftsAutomaticListFiltered() {
      let filtered = this.giftsAutomaticList

      if (this.categoriesSelected.length) {
        filtered = this.giftsAutomaticList.map((section) => {
          const filteredByCategory = section.gifts_lists.filter((list) => {
            return !!this.categoriesSelected.find(
              (category) => category === list.name
            )
          })
          return {
            ...section,
            gifts_lists: filteredByCategory,
          }
        })
      }

      return filtered.filter((section) => !!section.gifts_lists.length)
    },

    giftsAutomaticListFilteredWithPaginate() {
      const count = isMobileBrowser()
        ? this.giftCount
        : this.giftsAutomaticListFiltered.length
      return this.giftsAutomaticListFiltered.slice(0, count)
    },

    seeMoreVisibility() {
      if (!isMobileBrowser()) return false
      return this.giftCount < this.giftsAutomaticListFiltered.length
    },
  },

  methods: {
    getGiftsAutomaticListsInfo() {
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi
        .getGiftsAutomaticListsInfo()
        .then((response) => {
          this.giftsAutomaticListSaved = [...response.data]
          this.giftsAutomaticList = [...response.data]
        })
        .catch((error) => console.error(error))
    },
    addGiftsAutomaticList(id, operation) {
      var data = {
        lista_automatica: String(id),
        acao: operation,
      }
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi
        .addGiftsAutomaticList(data)
        .then((response) => {
          if (response) {
            this.confirmation = false
            this.selectedList = false
            this.$store.dispatch('gifts/fetchGiftsList')
            this.$parent.close()
            this.$scrollTo('.dashboard-content')
          }
        })
        .catch((error) => console.error(error))
    },
    getListUrlImage(listId) {
      return `${API_LEGACY_URL}/img/layout/listas-automaticas-capas/` + listId
    },
    getGiftUrlImage(giftId) {
      return `${API_LEGACY_URL}/img/presentes/` + giftId
    },
    getGiftValue(value) {
      value = parseFloat(value)
      return value.toLocaleString('PT-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      })
    },
    loadMoreGifts() {
      if (this.giftCount < this.giftsAutomaticListFiltered.length) {
        this.giftCount += 1
      }
    },
    cleanFilters() {
      this.categoriesSelected = []
      this.open = false
    },
    queringPag() {
      this.giftCount = INITIAL_COUNT
      this.giftsAutomaticList = this.giftsAutomaticListSaved.map((section) => {
        const query = this.query ? this.query.toLowerCase() : ''
        const giftsAutomaticListFiltered = section.gifts_lists.filter(
          (list) => {
            return !!list.name.toLowerCase().includes(query)
          }
        )
        return {
          ...section,
          gifts_lists: giftsAutomaticListFiltered,
        }
      })
    },

    openFilters() {
      this.open = true
    },
    closeFilters() {
      this.giftCount = INITIAL_COUNT
      this.open = false
    },

    openConfirmation() {
      if (this.giftsListSaved.length > 0) {
        this.confirmation = true
      } else {
        this.addGiftsAutomaticList(this.listSelected.id, 'add')
      }
    },
    openSelectedList(list) {
      this.listSelected = list
      const giftsApi = new GiftsApi(this.logonToken)
      giftsApi
        .getGiftsAutomaticList(list.id)
        .then((response) => {
          this.gifts = response.data
          this.selectedList = true
        })
        .catch((error) => console.error(error))
    },
    closeSelectList() {
      this.selectedList = false
    },
    removeFromSearch(categoryToRemove) {
      this.categoriesSelected = this.categoriesSelected.filter(
        (category) => category !== categoryToRemove
      )
    },
    applyFilters() {
      this.open = false
    },
    goTop() {
      document.getElementById('headerDrawer').scrollIntoView()
    },
  },
}
</script>

<style lang="scss" scoped>
#headerDrawer {
  position: absolute;
  margin-top: -100px;
}

.ready-list {
  margin-top: 60px;
  margin-bottom: 130px !important;

  @media (max-width: $mobile) {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 16px;
    margin-right: 16px;
  }

  .ready-list-title {
    font-size: 18px;
    font-weight: 700;
    color: #3dafb0;
    margin-bottom: 16px;
  }

  .ready-list-subtitle {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 16px;
    color: $neutral;

    .ready-list-subtitle-bold {
      font-weight: 700;
    }
  }

  .ready-list-text {
    color: $neutral;
    font-weight: 400;
  }
}

.gift-ready-label {
  font-size: 16px;
  color: $neutral;
  font-weight: 400;
  margin-top: 0px;
  margin-bottom: 40px;

  @media (max-width: $mobile) {
    margin-top: 24px;
    margin-bottom: 24px;
  }
}

.filter-gifts-sidebar {
  .filter-header {
    display: flex;
    align-items: center;
    height: 66px;
    border-bottom: 2px solid $neutrallight;
    box-shadow: 0px 2px 4px rgba(93, 117, 141, 0.3);
    padding: 22px;
    font-size: 22px;
    font-weight: 700;
    color: $neutral;
    position: fixed;
    width: 100%;
    background: #fff;
    z-index: 1;

    img {
      padding-right: 22px;
      cursor: pointer;
    }
  }

  .filter-content {
    padding-top: 32px;
    overflow: hidden;
    margin-left: 32px;
    margin-right: 32px;

    .gift-category {
      display: flex;
      justify-content: flex-start;
      flex-flow: wrap;
      margin: 0 -14px;
      @media (max-width: $mobile) {
        text-align: center;
        display: flex;
        flex-shrink: 0;
        flex-flow: row wrap;
        align-items: flex-end;
      }

      .gift-items-card {
        text-align: center;
        display: block;
        flex: none;
        cursor: initial;
        overflow: hidden;
        padding: 0 14px 20px;
        margin: 20px 0 0;

        @media (max-width: $mobile) {
          max-width: 50%;
          text-align: center;
          padding-bottom: 12px;
          margin: 12px 0 0;
        }

        .gift-items-card-content {
          padding: 16px;
          border: 1px solid #dde7f1;
          box-shadow: 0px 10px 15px rgba(93, 117, 141, 0.1);
          border-radius: 16px;

          @media (max-width: $mobile) {
            width: 100%;
          }

          .gifts-items-card-close {
            width: 32px;
            height: 32px;

            position: absolute;
            text-align: right;
            margin-left: 172px;
            margin-top: -10px;
            cursor: pointer;
            filter: drop-shadow(0px 2px 4px rgba(93, 117, 141, 0.2));
          }

          .gift-items-card-image {
            width: 208px;
            height: 208px;
            border-radius: 16px;
            margin-bottom: 8px;
            object-fit: cover;

            @media (max-width: $mobile) {
              width: 144px;
              height: 144px;
              border-radius: 16px;
              margin-bottom: 8px;
            }
          }

          .gift-items-card-title {
            font-size: 14px;
            font-weight: 400;
            color: $neutral;
            margin-bottom: 8px;
            height: 34px;
            display: -webkit-box;
            line-clamp: 2;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 208px;
            height: 40px;
            padding-left: 12px;
            padding-right: 12px;
            text-align: center;
            margin-top: 0px;

            @media (max-width: $mobile) {
              width: auto;
              font-size: 14px;
              font-weight: 400;
              color: $neutral;
              margin-bottom: 8px;
              display: -webkit-box;
              line-clamp: 2;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              padding-left: 12px;
              padding-right: 12px;
              line-height: 16px;
              height: 32px !important;
            }
          }

          .gift-items-card-value {
            font-size: 18px;
            font-weight: 700;
            color: $neutral;
            height: 40px;
            text-align: center;
          }

          .gift-items-card-edit {
            font-size: 14px;
            color: #3dafb0;
            display: flex;
            vertical-align: middle;
            cursor: pointer;
            margin-right: 10px;
            align-items: center;
            justify-content: center;

            img {
              width: 20px;
              margin-right: 10px;
            }
          }
        }
      }
    }

    //selected-list end

    .filter-content-category-title {
      font-size: 20px;
      font-weight: 700;
      color: $neutral;
      margin-top: 64px;
      margin-bottom: 24px;
    }

    .filter-content-confirmation-title {
      font-size: 18px;
      font-weight: 700;
      color: $neutral;
      margin-top: 64px;
      margin-bottom: 24px;
    }

    .filter-content-confirmation-option {
      display: flex;
      align-items: center;
      border: 1px solid #dde7f1;
      border-radius: 16px;
      padding: 24px;
      margin-bottom: 24px;
      cursor: pointer;

      .filter-content-confirmation-option-image {
        img {
          min-width: 20px;
        }
      }

      .filter-content-confirmation-text {
        margin-left: 24px;
        color: $neutral;

        @media (min-width: $desktop) {
          min-width: 90%;
        }

        .confirmation-title {
          font-size: 16px;
          font-weight: 700;
        }

        .confirmation-subtitle {
          font-size: 16px;
          font-weight: 400;
        }
      }

      .filter-content-confirmation-arrow {
        img {
          min-width: 20px;
        }
      }
    }

    .gift-filters-section {
      font-size: 16px;
      font-weight: 700;
      color: #3dafb0;
      margin-bottom: 26px;
    }

    .gift-filters-item {
      font-size: 16px;
      font-weight: 400;
      color: $neutral;
      margin-bottom: 26px;
    }

    .gift-filter-divider {
      border-bottom: 2px solid $neutrallightest;
      width: auto;
      max-width: 248px;
      align-self: center;
      height: 2px;
      margin-top: 30px;
      margin-bottom: 30px;
    }

    .gift-filters-range {
      .gift-filters-range-title {
        font-size: 20px;
        font-weight: 700;
        color: $neutral;
        margin-bottom: 24px;
      }

      .gift-filters-range-values {
        font-size: 16px;
        font-weight: 400;
        color: $neutral;
        margin-bottom: 26px;
      }
    }

    .gift-filters-range:nth-last-child(2) {
      margin-bottom: 192px !important;
    }
  }
}

.filter-gifts-sidebar-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: auto;
  right: 0;
  bottom: 0;
  left: 0;
  margin-bottom: 0px;
  width: 100%;
  background: #fff;
  z-index: 1;
  min-height: 162px;
  padding-top: 16px;
  padding-bottom: 16px;
  text-align: center;
  border-top: 2px solid $neutrallight;
  box-shadow: 0px -2px 4px rgba(93, 117, 141, 0.3);
  @media (max-width: $tablet) {
    width: 100vw;
  }

  @media (min-width: $desktop) {
    min-height: 112px;
    .button {
      width: auto !important;
    }
  }

  .wrapper-buttons {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    padding: 0 16px;
    @media screen and (min-width: $desktop) {
      flex-direction: row;
    }
  }

  .button {
    display: block;
    flex: none;
    width: 100%;
    max-width: 360px;
    margin: 0 auto;
    height: 56px;
    font-size: 18px;
    font-weight: bold;
    border-radius: 100px;
    &:last-child {
      margin-bottom: 8px;
    }

    @media screen and (min-width: $desktop) {
      max-width: 100%;
      width: auto;
      margin: 0 24px 0 0;
      &:last-child {
        margin-right: 0;
        margin-bottom: 0;
      }
    }
  }

  .btn-clean {
    color: #fff;
    background-color: rgba(180, 197, 214, 0.8);
    border-color: rgba(180, 197, 214, 0.8);
  }
}

.gift-category-search {
  display: flex;
  align-items: center;

  @media (max-width: $mobile) {
    display: inline-block;
    width: 100%;

    .filter-button-wrapper {
      width: 100%;
      margin-bottom: 24px;

      .filter-button {
        width: 100%;
        font-size: 16px;
      }
    }

    .gift-edit-search {
      width: 100%;
    }
  }

  .filter-button-active {
    border: 1px solid $primary !important;

    .filter-count {
      color: #fff;
      background-color: $primary;
      margin-left: 8px;
      border-radius: 100px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 2px;
    }
  }

  .filter-button {
    color: $neutral;
    background-color: #f9fbfd;
    border: 1px solid #e9eef3;
    font-size: 16px;
    font-weight: 700;
    width: 100%;
    display: flex;
    height: 56px;
    border-radius: 16px;
    align-items: center;
    justify-content: center;
    width: 241px;
    margin-right: 20px;
    cursor: pointer;
    border-radius: 16px;

    img {
      margin-right: 12px;
    }
  }

  .gift-edit-search {
    display: block;
    align-items: center;
    width: 100%;

    .gift-list-search-wrapper {
      width: 100%;
      height: 56px;
      background-color: #fff;
      border-radius: 16px;
      margin-left: 0px;
      margin-right: 0px;
      display: flex;
      align-items: center;
      float: left;
      border: 1.5px solid #dde7f1;
      color: $neutral;

      .icon-search {
        width: 16px;
        height: 16px;
        margin-left: 20px;
        opacity: 0.5;
      }

      .gift-list-search {
        background-color: #fff !important;
        border-radius: 16px;
        width: 100%;
        height: 52px;
        border-color: transparent;

        float: left;
        font-size: 16px;
        color: $neutral;
      }

      .gift-list-search::placeholder {
        color: $neutral;
      }

      .gift-list-search:focus,
      input:focus {
        outline: none;
      }
    }
  }
}

.gift-category::after {
  content: '';
  flex: 0 0 28.5%;
  max-width: 480px;
}

.filter-mobile {
  display: none !important;

  @media (max-width: $mobile) {
    display: block !important;
  }
}

.filter-desktop {
  display: block;

  @media (max-width: $mobile) {
    display: none !important;
  }
}

.filter-element {
  margin: 32px 0 0;
  display: block;

  @media (max-width: $mobile) {
    margin: -8px 0 24px;
    .filter-element-item {
      display: inline-flex !important;
      width: 30% !important;
      margin-right: 10px;
    }
  }

  .filter-element-item {
    background-color: #3dafb0;
    width: 132px;
    padding: 12px;
    border-radius: 100px;
    height: 32px;
    color: #fff;
    align-items: center;
    display: inline-flex;
    font-size: 14px;
    font-weight: 700;
    margin-right: 8px;
    margin-top: 8px;

    .filter-text {
      white-space: nowrap;
      width: 85px;
      overflow: hidden;
      padding-bottom: 5px;
      padding-top: 5px;
      text-overflow: ellipsis;
    }

    .close-search {
      padding-left: 12px;
      cursor: pointer;
    }
  }
}

.gift-category {
  margin-top: 40px;
  overflow: hidden;

  @media (max-width: $mobile) {
    text-align: center;
    padding: 0px 0px 0px 0px !important;
    margin: auto;
    flex-shrink: 0;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-end;
    justify-content: center;
  }

  .gift-category-section {
    color: #3dafb0;
    text-align: left;
    font-size: 18px;
    font-weight: 700;
    margin-top: 0px;
    margin-bottom: 40px;

    @media (max-width: $mobile) {
      margin-top: 24px;
      margin-bottom: 24px;
    }
  }

  .gift-items-card-row {
    @media (min-width: $mobile) {
      overflow: hidden;
      display: flex;
      margin: 0 -14px;
      flex-wrap: wrap;
    }
  }

  .gift-category-separation-section {
    @media (min-width: $desktop) {
      border-top: 1px solid $neutrallight;
      width: 100%;
      margin-top: 40px;
      display: none;
    }
  }

  .gift-items-card {
    position: relative;
    text-align: center;
    display: block;
    flex: none;
    width: 33.33%;
    cursor: pointer;
    padding: 0 14px 40px;
    margin: 0 0 40px;
    &.without-border:after {
      display: none;
    }
    &:after {
      content: '';
      position: absolute;
      top: auto;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100vw;
      height: 1px;
      background-color: $neutrallight;
    }

    @media (max-width: $mobile) {
      width: 100%;
      text-align: center;
      margin: 24px 0 0;
      padding: 0 0 24px;
    }

    .gift-items-card-content {
      width: 100%;
      margin: 0 auto;
      border-radius: 16px;

      .gift-items-card-image {
        width: 100%;
        height: 200px;
        border-radius: 16px;
        object-fit: cover;

        @media (max-width: $mobile) {
          max-width: 100%;
          width: 100%;
          height: 236px;
          border-radius: 16px;
        }
      }

      .gift-items-card-title {
        font-size: 16px;
        font-weight: 700;
        color: #3dafb0;
        margin-top: 8px;
        margin-bottom: 8px;
        text-align: left;
        line-height: 140%;
      }

      .gift-items-card-value {
        font-size: 16px;
        font-weight: 400;
        color: $neutral;
        text-align: left;
        line-height: 140%;
      }

      .gift-filter-separation {
        display: none;

        @media (max-width: $mobile) {
          display: block;
          border-bottom: 1px solid $neutrallight;
          width: auto;
          align-self: center;
          height: 2px;
          margin-top: 24px;
          margin-bottom: 30px;
        }
      }

      .gift-filter-separation-row {
        display: block;
        border-bottom: 1px solid $neutrallight;
        width: 753px;
        align-self: center;
        height: 2px;
        margin-top: 40px;
        margin-bottom: 40px;

        @media (max-width: $mobile) {
          display: none;
        }
      }
    }
  }
}

.gift-category-footer {
  margin-top: 24px;
  text-align: center;

  .button {
    @media (max-width: $mobile) {
      margin-top: 24px;
      width: auto;
      height: 56px;
      border-radius: 100px;
    }

    img {
      margin-right: 8px;
    }
  }

  .btn-back-initial {
    margin-top: 32px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;

    a {
      color: #5d758d;
    }

    a:hover {
      color: #5d758d;
    }

    img {
      width: 9px;
      height: 9px;
      margin-right: 8px;
    }
  }
}

::-webkit-scrollbar {
  width: 10px;
}

.content {
  margin-top: 40px;
  margin-left: 32px;
  margin-right: 32px;
  margin-bottom: 40px;

  @media (max-width: $mobile) {
    margin-top: 24px;
    margin-left: 16px;
    margin-right: 16px;
  }
}

.counter {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  color: $white;
  border-radius: 100%;
  margin-left: 12px;
  background-color: $primary;
}
</style>
